import type { FC } from 'react';
import { NumberFormatValues } from 'react-number-format';
import { FormInputProps } from '../FormInputProps';
import NumberInputsTemplate from '../NumberInputsTemplate/NumberInputsTemplate';

export interface FormInputCurrencyProps extends FormInputProps {
  placeholder?: string;
  defaultValue?: string | number;
  prefix?: string;
  suffix?: string;
  required?: boolean;
  min?: 0 | 1;
  testId?: string;
}

const FormInputCurrency: FC<FormInputCurrencyProps> = ({
  name,
  label,
  placeholder,
  required,
  min = 1,
  disabled,
  prefix = '€ ',
  suffix,
  shouldUnregister = false,
  testId,
  defaultValue,
}) => {
  const validateUsingMinProp = (values: NumberFormatValues): boolean => {
    const { floatValue } = values;
    let valid = true;
    valid = valid && (floatValue === undefined || floatValue >= min);

    return valid;
  };

  return (
    <NumberInputsTemplate
      suffix={suffix}
      defaultValue={defaultValue}
      name={name}
      label={label}
      placeholder={placeholder}
      prefix={prefix}
      required={required}
      disabled={disabled}
      shouldUnregister={shouldUnregister}
      fixedDecimalScale
      thousandSeparator
      testId={testId}
      handleIsAllowed={validateUsingMinProp}
    />
  );
};

export default FormInputCurrency;
